import type { DatadogInstaller } from "./types";

export const datadogInstaller: DatadogInstaller = {
  components: {
    "audit-log": {
      items: {
        endpoint: {
          labeler: () => "Intake URL",
        },
        apiKey: {
          labeler: () => "API key",
        },
        service: {},
      },
    },
  },
};
